/* eslint-disable */
// JavaScript Document
/**
 *	ボタンの選択状態の変更
 */

function selectButton(target){

  $("#newsBoxMenuAllNewsButton").removeClass("select");
  $("#newsBoxMenuClassNewsButton").removeClass("select");
  $("#newsBoxMenuCollegeNewsButton").removeClass("select");
  $("#newsBoxMenuUpdateNewsButton").removeClass("select");
  $("#newsBoxMenuVC2NewsButton").removeClass("select");



  target.addClass("select");

}



/**
 *	News詳細リンクの作成
 */

function initFacebox(){

  loadingGif = "../../js/libs/facebox/loading.gif"
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    loadingGif="/" + SUPER_EIGO_CONTEXT_PATH + "/js/libs/facebox/loading.gif"
  }

  closeGif="../../js/libs/facebox/closelabel.gif"
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    closeGif="/" + SUPER_EIGO_CONTEXT_PATH + "/js/libs/facebox/closelabel.gif"
  }

  $('#newsLoadArea a[rel*=facebox]').facebox({
    loadingImage : loadingGif,
    closeImage   : closeGif
  })
}


/**
 *	すべてのニュースを取得する
 */

function loadAllNewsLogin(target_type){


  news_url="../../news/new_info.cfm?target_type="+target_type+'&rand='+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/new_info.cfm?target_type="+target_type+'&rand='+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){
    initFacebox();
    selectButton($("#newsBoxMenuAllNewsButton"));
  });
}

/**
 *	すべてのニュースを取得する
 */

function loadAllNews(target_type){

  news_url="../../news/list/allNews.cfm?target_type="+target_type+'&rand='+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/list/allNews.cfm?target_type="+target_type+'&rand='+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){


    initFacebox();
    selectButton($("#newsBoxMenuAllNewsButton"));
  });
}


/**
 *	クラスからのお知らせを取得する
 */

function loadClassNews(){

  news_url="../../news/list/classNews.cfm?rand="+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/list/classNews.cfm?rand="+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){

    initFacebox();
    selectButton($("#newsBoxMenuClassNewsButton"));
  });
}

/**
 *	大学からのお知らせを取得する
 */

function loadCollegeNews(target_type,security_flag){

  news_url="../../news/collegeNews.cfm?target_type="+target_type+"&security_flag="+security_flag+'&rand='+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/collegeNews.cfm?target_type="+target_type+"&security_flag="+security_flag+'&rand='+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){
    initFacebox();
    selectButton($("#newsBoxMenuCollegeNewsButton"));
  });
}
/**
 *	更新情報を取得する
 */

function loadUpdateNews(){

  news_url="../../news/updated_info.cfm?rand="+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/updated_info.cfm?rand="+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){
    initFacebox();
    selectButton($("#newsBoxMenuUpdateNewsButton"));
  });
}

/**
 *	VC2（未読）のお知らせを取得する
 */

function loadVCNews(target_type,security_flag){

  news_url="../../news/vc_info.cfm?target_type="+target_type+"&security_flag="+security_flag+'&rand='+new Date().getTime();
  if(typeof SUPER_EIGO_CONTEXT_PATH != "undefined") {
    news_url="/" + SUPER_EIGO_CONTEXT_PATH + "/news/vc_info.cfm?target_type="+target_type+"&security_flag="+security_flag+'&rand='+new Date().getTime();
  }

  $("#newsLoadArea").load(news_url, null, function(){
    initFacebox();
    selectButton($("#newsBoxMenuVC2NewsButton"));
  });
}

window.selectButton = selectButton;
window.initFacebox = initFacebox;
window.loadAllNewsLogin = loadAllNewsLogin;
window.loadAllNews = loadAllNews;
window.loadClassNews = loadClassNews;
window.loadCollegeNews = loadCollegeNews;
window.loadUpdateNews = loadUpdateNews;
window.loadVCNews = loadVCNews;



// WEBPACK FOOTER //
// ./es6/admin-pages-js/etc/info.js